import App from './App.svelte';
import {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Tab,
  Modal,
  Popover,
  ScrollSpy,
  Toast,
  Tooltip,
} from 'bootstrap';

const app = new App({
  target: document.body,
  props: {
    name: 'world',
  },
});

export default app;
